import styled from 'styled-components';

import {FareBreakUpTipOuterWrap} from '../FareBreakup/FareBreakup.styles';

export const BookedHtlRoomInfoWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: 0 ${props.theme.spacing.large.l18} ${props.theme.spacing.large.l20};
  `
);

export const BookedHtlRoomInfoInnerWrap = styled.div(
  props => `
      width:80%;
      display: flex;
      flex-direction: column;
  `
);

export const BookedHtlRoomNameWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      flex-direction: column;
  `
);

export const BookedHtlRoomName = styled.p(
  props => `
      font-size: ${props.theme.font.large.font18};
      color: ${props.theme.colors.black.base};
      font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const BookedHtlRoomAmenitiesWrap = styled.div(
  props => `
      display: flex;
      justify-content: flex-start;
  `
);

export const BookedHtlRoomAmenitesText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
      line-height: ${props.theme.font.lineHeight.base};
  `
);

export const BookedHtlRoomPriceInfoWrap = styled.div(
  props => `
    width:20%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    padding: ${props.theme.spacing.large.l20} 0 0;
  `
);

export const BookedHtlPriceText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font25};
      color: ${props.theme.colors.black.base};
      font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const BookedPirceTaxText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.base};
  `
);

export const FareDetailWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      margin-top: ${props.theme.spacing.base};
      justify-content: flex-end;
      position: relative;
        &:hover{
          ${FareBreakUpTipOuterWrap}{
              opacity: 1;
          }
        }
  `
);

export const FareDetailText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.blue.base};
      font-weight: ${props.theme.font.fontWeight.black};
      cursor: pointer;
  `
);

export const BookedHtlLocText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.base};

      span{
          color: ${props.theme.colors.black.base};
          font-weight: ${props.theme.font.fontWeight.bold};
      }
      .greenText{
          color: ${props.theme.colors.green.base};
      }
  `
);

export const BookedHtlRoomDetailInnerWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: ${props.theme.spacing.large.l20} 0 0;
  `
);
